import axios from 'axios';
import { setupAxiosInterceptor } from './auth/axiosConfig';
import config from './config';

const leadApi = axios.create({
  baseURL: config.API_BASE_URL + '/cellcog',
});

setupAxiosInterceptor(leadApi);

// ==================== Public Lead API ====================

/**
 * Submit a marketing lead (public endpoint - works logged out).
 * @param {Object} data - { name, email, message, role?, source_page?, botcheck? }
 * @returns {Promise} Response with { success, message }
 */
export const createLead = (data) => {
  return leadApi.post('/leads', data);
};

// ==================== Admin Lead APIs ====================

/**
 * Get lead statistics (admin only)
 * @returns {Promise} Response with { total, by_status, by_role, last_7_days }
 */
export const getLeadStats = () => {
  return leadApi.get('/admin/leads/stats');
};

/**
 * List all leads (admin only)
 * @param {Object} params - { page, page_size, status?, role?, search?, sort? }
 * @returns {Promise} Response with leads list
 */
export const listAllLeads = (params) => {
  return leadApi.get('/admin/leads', { params });
};

/**
 * Update a lead's status or admin notes (admin only)
 * @param {string} leadId
 * @param {Object} data - { status?, admin_notes? }
 * @returns {Promise} Updated lead
 */
export const updateLead = (leadId, data) => {
  return leadApi.patch(`/admin/leads/${leadId}`, data);
};
